export enum CustomerAccFundTypeEnum {
    Conventional = 1,
    Islamic = 2,
}

export enum CustomerGenderEnum {
    Male = 1,
    Female = 2,
    'N/A' = 3,
}

export enum CustomerRaceEnum {
    Malay = 1,
    Chinese = 2,
    Indian = 3,
    Others = 4,
    'N/A' = 5,
}

export enum CustomerIdTypeEnum {
    IC = 1,
    Passport = 2,
    'Company Registration No' = 3,
    // 'Birth Certificate' = 4,
    MyTentera = 5
}

export enum CustomerAccStatusEnum {
    Active = 1,
    Deactivated = 2,
}

export enum ProjectAccStatusEnum {
    Active = 1,
    Deactivated = 2,
}

export enum ProjectChangeHistoryStatusEnum {
    Pending = 1,
    Approved = 2,
    Rejected = 3,
}

export enum NavigationTabsEnum {
    Dashboard = 'Dashboard',
    CustomerManagement = 'Customer Management',
    ProductManagement = 'Product Management',
    GoldManagement = 'Gold & Silver Management',
    GoldManagementBuyAndSellGold = 'Buy & Sell',
    GoldManagementGoldInventory = 'Inventory',
    GoldManagementGoldInventoryReport = 'Inventory Report',
    GoldManagementInventoryTransactions = 'Inventory Transactions',
    GoldManagementSerialNumberSearch = 'Serial Number Search',
    // GoldManagementStockOut = 'Stock Out',
    Conversion = 'Conversion',
    Approval = 'Approval',
    BranchManagement = 'Branch Management',
    BranchManagementRegions = 'Regions',
    BranchManagementBranches = 'Branches',
    AdminManagement = 'Admin Management',
    AdminManagementRoles = 'Roles',
    AdminManagementAdmins = 'Admins',
    Discount = 'Discount',
    Settings = 'Settings',
    Report = 'Reports',
    ReportSalesReport = 'Sales Report',
    ReportInventoryReport = 'Inventory Report',
    SplitSettings = 'Product',
    ProjectManagement = 'Project Management',
    MarketStatus = 'Market Status',
    StockOut = 'Stock Out',
    CustomerTransfer = 'Customer Transfer',
}

export enum TransactionActionEnum {
    'Bank Sell' = 1,
    'Bank Buy' = 2,
}

export enum GoldTypeEnum {
    PhysicalGold = 1,
    PaperGold = 2,
}

export const GoldTypeDisplayMap: Record<GoldTypeEnum, string> = {
    [GoldTypeEnum.PhysicalGold]: 'Physical Gold',
    [GoldTypeEnum.PaperGold]: 'Paper Gold',
};

export enum SilverTypeEnum {
    PhysicalSilver = 1,
    PaperSilver = 2,
}

export const SilverTypeDisplayMap: Record<SilverTypeEnum, string> = {
    [SilverTypeEnum.PhysicalSilver]: 'Physical Silver',
    [SilverTypeEnum.PaperSilver]: 'Paper Silver',
};

export enum SilverGoldTypeEnum {
    Physical = 1,
    Paper = 2,
}

export enum SilverConversionStatusEnum {
    Pending = 1,
    Approved = 2,
    Rejected = 3,
}

export enum TransactionStatusEnum {
    Pending = 1,
    Approved = 2,
    Rejected = 3,
    Cancelled = 4,
}

export enum TransferStatusEnum {
    PendingDeliver = 1,
    PendingReceive = 2,
    Approved = 3,
    RejectedDeliver = 4,
    RejectedReceive = 5,
}

export enum EarmarkReleaseRequestStatusEnum {
    Pending = 1,
    Approved = 2,
    Rejected = 3,
}

export enum GoldConversionStatusEnum {
    Pending = 1,
    Approved = 2,
    Rejected = 3,
}

export enum InventoryActionEnum {
    TransferTo = 1,
    TransferFrom = 2,
    Restock = 3,
    NewProduct = 4,
    BankSell = 5,
    BankBuy = 6,
    RejectTransaction = 7,
    CancelTransaction = 8,
    Conversion = 9,
    StockOut = 10,
}

export enum MetalTypeEnum {
    Gold = 1,
    Silver = 2,
}

export enum GoldSilverTypeEnum {
    Physical = 1,
    Paper = 2,
}

export enum FundTypeEnum {
    Conventional = 1,
    Islamic = 2,
}

export enum AdminSettingsTypeEnum {
    Default = 1,
    Product = 2,
}

export enum AdminSettingsChangeTypeEnum {
    Create = 1,
    Edit = 2,
    Delete = 3,
}

export enum SettingTabsEnum {
    Global = 1,
    Products = 2,
    APIKey = 3,
    SilverAPIKey = 4,
}

export const SettingsTabDisplayMap: Record<SettingTabsEnum, string> = {
    [SettingTabsEnum.APIKey]: 'Gold APIKey',
    [SettingTabsEnum.SilverAPIKey]: 'Silver APIKey',
    [SettingTabsEnum.Global]: 'Global',
    [SettingTabsEnum.Products]: 'Product',
};

export enum ApprovalTabsEnum {
    'Buy & Sell' = 1,
    'Inventory',
    'Discount',
    'Product Management',
    'Collateral',
    'Project Management',
    'Transfers',
    'Release Earmark',
    'Branch',
    'Conversion',
    'Earmark Conversion',
    'Stock Out',
    'Customer Transfer'
}

export enum InventoryReportTabsEnum {
    'Inventory Received' = 1,
    'Inventory Delivered',
    'Branch Inventory',
}

export enum RoleStatusEnum {
    Active = 1,
    Deactivated = 2,
}
export enum ExportPermissionsEnum {
    View = 1,
    Create = 2,
    Edit = 3,
}
export enum PermissionsEnum {
    View = 1,
    Create = 2,
    Edit = 3,
    Delete = 4,
}

export enum ModuleEnum {
    Dashboard = 1,
    CustomerManagement = 2,
    Product = 3,
    BuySellGold = 4,
    Conversion = 5,
    Approval = 6,
    BranchManagement = 7,
    RBAC = 8,
    Inventory = 9,
    InventoryTransaction = 10,
    Discount = 11,
    InventoryTransfer = 12,
    Setting = 13,
    Report = 14,
    Project = 15,
    Collateral = 16,
    MarketStatus = 17,
    CustomerTransfer = 18,
    InventoryStockOut = 19,
    SalesReport = 20,
    InventoryReport = 21,
}

export enum BinaryStatusEnum {
    Active = 1,
    Deactivated = 2,
}

export enum AuthUserStatusEnum {
    Active = 1,
    Deactivated = 2,
}

export enum BranchStatusEnum {
    Active = 1,
    Deactivated = 2,
    Deleted = 3,
}

export enum BranchApprovalStatusEnum {
    Pending = 1,
    Approved = 2,
    Rejected = 3,
}

export enum RegionStatusEnum {
    Active = 1,
    Deactivated = 2,
}

export enum CustomerAccTypeEnum {
    Individual = 1,
    Joint = 2,
}

export enum DiscountStatusEnum {
    Active = 1,
    Deactivated = 2,
}

export enum DiscountTypeEnum {
    'Percentage' = 1,
    'Fixed' = 2,
}

export enum DiscountUsageTypeEnum {
    'One-time' = 1,
    'Multiple' = 2,
}

export enum ProductStatusEnum {
    Active = 1,
    Deactivated = 2,
}

export enum SerialNumberStatusEnum {
    Sold = 1,
    Unsold = 2
}

export enum MarketStatusEnum {
    Open = 1,
    Close = 2,
}

export enum EarmarkStatusEnum {
    PendingRelease = 1, // ! DEPRECATED based on BE
    Released = 2,
    NotMatured = 3
}

export enum CustomerTransferStatusEnum {
    Pending = 1,
    Approved = 2,
    Rejected = 3,
}

export enum ReportInventoryReportSelectedTab {
    InventoryReceived = 1,
    InventoryDelivered = 2,
    BranchInventory = 3,
}

export enum MovementType {
    ApprovedBankSell = 1,
    CancelledBankSell = 2,
    ApprovedBankBuy = 3,
    CancelledBankBuy = 4,
    ApprovedStockIn = 5,
    CancelledStockIn = 6,
    ApprovedStockOut = 7,
    ApprovedConversion = 8
}
